import { InjectionToken, Type } from '@angular/core';

export const WIRE_CUT_CART_ITEM_RESULT_VIEW_COMPONENTS = new InjectionToken<Type<unknown>[]>('WIRE_CUT_CART_ITEM_RESULT_VIEW_COMPONENTS', {
  providedIn: 'root',
  factory: () => [],
});
